@for (category of categories; track category.id; let categoryIndex = $index) {
    <div class="live-casino__container">
        <div class="live-casino__header" [innerHTML]="category.name"></div>
        <div class="live-casino__games">
            <ms-scroll-adapter [scrollItems]="category.games">
                @for (game of category.games; track game.id; let index = $index) {
                    <a [attr.data-productid]="getGameDataProductId(category, game)" (click)="launchGame(category, game, categoryIndex, index)">
                        <img class="live-casino__game-img" width="138" height="138" [ngSrc]="game.imageUrl" />
                    </a>
                }
            </ms-scroll-adapter>
        </div>
    </div>
}
